import axios from 'axios';
import route from "ziggy-js";
import { Ziggy } from '../../js/ziggy';

let http = axios.create({
    baseURL: window.VTSolucoes.apiURL,
    timeout: 100000,
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-VT-SOLUCOES': 'v' + window.VTSolucoes.version,
        'X-CSRF-TOKEN': window.VTSolucoes.csrfToken
    },
    withCredentials: true
});

http.interceptors.request.use((config) => {
    // Do something before request is sent
    $("#overlay").show();
    return config;
}, function(error) {
    // Do something with request error
    console.log('Error');
    $("#overlay").hide();
    return Promise.reject(error);
});

http.interceptors.response.use(
    (response) => {
        $("#overlay").hide();
        return response;
    },
    async (error) => {
        $("#overlay").hide();
        if (error.request.status === 401) {
            // Refresh token has failed. Logout the user
            store.dispatch('auth/logout');
            throw error;
        }
        // If error was not 401 just reject as is
        throw error;
    }
);

const ApiService = {
    // Stores the 401 interceptor position so that it can be later ejected when needed
    _401interceptor: null,

    setHeader() {
        //http.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`
    },

    removeHeader() {
        http.defaults.headers.common = {}
    },

    get(resource) {
        return http.get(resource)
    },

    getArrayBuffer(resource) {
        return http.get(resource, {responseType: 'arraybuffer'})
    },

    getStream(resource) {
        return http.get(resource, {responseType: 'stream'})
    },

    post(resource, data) {
        return http.post(resource, data)
    },

    put(resource, data) {
        return http.put(resource, data)
    },

    delete(resource) {
        return http.delete(resource)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
     **/
    customRequest(data) {
        return http(data)
    },

    rotas(name, params, absolute) {
        return route(name, params, absolute, Ziggy);
    }
};

export default ApiService;
